import imagePreview from '../modules/image-preview';

const initialize = () => {
    const logoInput = document.getElementById('logoInput');
    if (!logoInput) {
        return;
    }

    logoInput.addEventListener('change', function () {
        if (!logoInput.files || !logoInput.files[0]) {
            return;
        }

        imagePreview(logoInput.files[0], (imagePath) => {
            if (imagePath) {
                let imageElement = document.getElementById('image');

                if (!imageElement) {
                    imageElement = document.createElement('img');
                    imageElement.id = 'image';
                    imageElement.className = 'logo';
                    document.getElementById('domain-logo-image').appendChild(imageElement);
                }

                imageElement.setAttribute('src', imagePath);
            }
        });
    });
};

export default initialize;
